var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("prettifyTime")(_vm.remainedTime)))])])}
var staticRenderFns = []

export { render, staticRenderFns }